<template>
  <div id="addField">
    <div class="o-modal">
      <div class="o-modal-content">
        <div class="o-modal-header">
          <a
            @click="closeAddField()"
            class="close clickable"
          ><i class="far fa-times"></i></a>
          <p class="lead">Add a Header</p>
        </div><!-- /.o-modal-header -->
        <div class="o-modal-body">
          <form @submit.prevent>

            <!-- Label -->
            <div class="form-group">
              <label>Header Label</label>
              <input
                v-model="field.label"
                class="form-control"
              />
            </div><!-- /.form-group -->

            <!-- Select Field Type -->
            <div class="form-group" v-if="!editMode">
              <label>Header Type</label>
              <multiselect
                v-model="field.type"
                :options="fieldTypes"
                :allow-empty="false"
                :multiple="false"
                @select="changeType"
              />
            </div><!-- /.form-group -->

            <!-- COMPUTER VISION OPTIONS -->
            <div
              v-if="field.type === 'Computer Vision'"
              class="form-group"
            >
              <div
                class="alert alert-warning"
              >WARNING, computer vision is experiemental! This header lets you capture and analyze an image. You must have a <a href="https://roboflow.com" target="_blank" rel="noopener noreferrer">Roboflow</a> account to use this feature. <a href="https://orbitist.atlassian.net/wiki/spaces/EV/pages/138280963/Computer+Vision+in+Viticulture" target="_blank" rel="noopener noreferrer">Learn more >></a></div>
              <!-- <label>Computer Vision Actions</label>
              <multiselect
                v-model="field.options"
                :options="cvOptions"
                tag-placeholder="Choose CV Actions"
                placeholder="Choose CV Actions"
                :allow-empty="true"
                :multiple="true"
                :taggable="false"
              /> -->
              <label>Roboflow API Key <span class="text-danger">*</span></label>
              <input
                v-model="field.cvSettings.roboflowAPIKey"
                class="form-control"
              />
              <label>Model URL <span class="text-danger">*</span></label>
              <input
                v-model="field.cvSettings.modelURL"
                class="form-control"
              />
            </div><!-- /if Computer Vision -->

            <!-- Select Options -->
            <div
              v-if="field.type === 'Select'"
              class="form-group"
            >
              <label>Header Options</label>
              <multiselect
                v-model="field.options"
                :options="field.options"
                tag-placeholder="Add options here"
                placeholder="Add options here"
                :allow-empty="false"
                :multiple="true"
                :taggable="true"
                @tag="addTag"
              />
            </div><!-- /.form-group -->

            <!-- Include Time -->
            <b-form-checkbox
              v-if="field.type === 'Date and Time'"
              v-model="field.includeTime"
              class="mt-2 mb-2"
            >
              Include Time
            </b-form-checkbox>

            <!-- Minimum Number -->
            <div
              v-if="field.type === 'Number'"
              class="form-group"
            >
              <label>Min</label>
              <input
                v-model="field.min"
                class="form-control"
                type="number"
              />
            </div><!-- /.form-group -->

            <!-- Maximum Number -->
            <div
              v-if="field.type === 'Number'"
              class="form-group"
            >
              <label>Max</label>
              <input
                v-model="field.max"
                class="form-control"
                type="number"
              />
            </div><!-- /.form-group -->

            <!-- Step Setting -->
            <div
              v-if="field.type === 'Number'"
              class="form-group"
            >
              <label>Step</label>
              <input
                v-model="field.step"
                class="form-control"
                type="number"
              />
            </div><!-- /.form-group -->

            <!-- Suffix -->
            <div
              v-if="field.type === 'Number'"
              class="form-group"
            >
              <label>Suffix</label>
              <input
                v-model="field.suffix"
                class="form-control"
              />
            </div><!-- /.form-group -->

            <!-- Header Group-->
            <div
              class="form-group"
            >
              <label>Header Group<br /><small>You may assign each header to one group.</small></label>
              <multiselect
                v-if="showSelects"
                v-model="field.group"
                :options="headerGroups"
                tag-placeholder="New Group"
                placeholder="Add Groups Here"
                :allow-empty="true"
                :multiple="false"
                :taggable="true"
                @tag="addHeaderGroup"
                @remove="refreshGroupsUI"
                @select="refreshGroupsUI"
              />
            </div><!-- /.form-group -->

            <!-- Required Option -->
            <b-form-checkbox
              v-model="field.required"
              class="mt-2 mb-2"
            >
              Require Header
            </b-form-checkbox>

            <!-- Dynamic Log Header (inherits type from header above) -->
            <b-form-checkbox
              v-model="field.isLogEnabled"
              class="mt-2 mb-2"
            >
              Enable Logging Over Time
            </b-form-checkbox>

          </form>
        </div><!-- /.o-modal-body -->
        <div class="o-modal-footer">
          <div class="drawer-footer">
            <button
              v-if="!editMode"
              @click="addField()"
              class="btn btn-primary mr-1 w-50"
            >
              Add Header
            </button>
            <button
              v-if="editMode"
              @click="addField()"
              class="btn btn-primary mr-1 x-50"
            >
              Update Header
            </button>
            <button
              v-if="editMode"
              @click="confirmRemove = true"
              class="btn btn-danger"
            >
              Remove Header
            </button>
          </div><!-- /.float-right -->
        </div><!-- /.o-modal-footer -->
      </div><!-- /.o-modal-content -->
    </div><!-- /. o-modal -->
    <Confirm
      v-if="confirmRemove"
      text="DANGER! Are you sure you want to remove this header? THIS CANNOT BE UNDONE!!"
      v-on:confirmed="removeField($event)"
    />
  </div><!-- /#addField -->
</template>

<script>
import Confirm from '../Confirm'
import Multiselect from 'vue-multiselect'

export default {
  data () {
    return {
      headerGroups: [],
      showSelects: true,
      confirmRemove: false,
      // cvOptions: [
      //   'Count Clusters'
      // ],
      showRadio: true,
      fieldTypes: [
        'Text',
        'Number',
        'Select',
        'Date and Time',
        'Image',
        'Computer Vision'
      ],
      field: {
        label: '',
        type: 'Text',
        options: [],
        min: false,
        max: false,
        step: false,
        suffix: '',
        required: false,
        includeTime: false,
        group: false,
        isLogEnabled: false,
        cvSettings: {
          roboflowAPIKey: '',
          modelURL: ''
        }
      }
    }
  },
  components: {
    Multiselect,
    Confirm
  },
  props: [
    'editMode',
    'fieldIndex'
  ],
  computed: {
    collector: {
      get () {
        return this.$store.state.collector
      },
      set (value) {
        this.$store.commit('setCollector', value)
      }
    }
  },
  created () {
    if (this.editMode) {
      this.field = this.collector.fields[this.fieldIndex]
      if (typeof this.field.isLogEnabled !== 'boolean') this.field.isLogEnabled = false
    }
    // Setup existing header groups; allow multiple Image and Computer Vision headers
    this.collector.fields.forEach(field => {
      if (!field.group) {
        field.group = false
      } else {
        if (!this.headerGroups.includes(field.group)) {
          this.headerGroups.push(field.group)
        }
      }
    })
  },
  methods: {
    deriveLogValueType (headerType) {
      const t = (headerType || '').toLowerCase()
      if (t === 'number') return 'number'
      if (t === 'text') return 'text'
      if (t === 'select') return 'select'
      if (t === 'date and time') return 'datetime'
      if (t === 'image') return 'image'
      return 'text'
    },
    changeType () {
      console.log(this.field)
      this.field.options = []
      setTimeout(() => {
        if (this.field.type === 'Computer Vision') {
          console.log('Vision')
          this.field.options.push('Count Clusters')
        }
      }, 100)
    },
    removeField (confirmed) {
      if (confirmed) {
        this.confirmRemove = false
        this.collector.fields.splice(this.fieldIndex, 1)
        // If computer vision, remove all CV fields
        if (this.field.type === 'Computer Vision') {
          for (let i = this.collector.fields.length - 1; i >= 0; i--) {
            if (this.collector.fields[i].type === 'CV Number') {
              this.collector.fields.splice(i, 1)
            }
          }
        }
        this.$store.commit('toggleModal', 'addField')
      } else {
        this.confirmRemove = false
        return false
      }
    },
    addField () {
      // Validate that number fields with min and max also have step set
      if (this.field.type === 'Number' && (this.field.min || this.field.max) && !this.field.step) {
        // alert('You must enter min, max, and step. You may also leave all three of these settings blank.')
        this.$store.commit('setAlert', { active: true, message: 'You must enter min, max, and step. You may also leave all three of these settings blank.', level: 'alert-warning', timeout: 5000 })
        return false
      }
      if (this.field.type === 'Computer Vision') {
        if (!this.field.cvSettings.roboflowAPIKey || !this.field.cvSettings.modelURL) {
          this.$store.commit('setAlert', { active: true, message: 'You must enter your Roboflow API key, and model URL.', level: 'alert-warning', timeout: 5000 })
          return false
        }
      }
      if (this.editMode) {
        const fieldObj = {
          label: this.field.label,
          type: this.field.type,
          machine_name: this.field.machine_name,
          min: this.field.min,
          max: this.field.max,
          step: this.field.step,
          suffix: this.field.suffix || false,
          required: this.field.required,
          includeTime: this.field.includeTime || false,
          group: this.field.group || false,
          isLogEnabled: this.field.isLogEnabled === true,
          logValueType: this.deriveLogValueType(this.field.type),
          cvSettings: {
            roboflowAPIKey: this.field.cvSettings.roboflowAPIKey || '',
            modelURL: this.field.cvSettings.modelURL || ''
          }
        }
        if (this.field.type === 'Select') {
          fieldObj.options = this.field.options
        }
        this.collector.fields[this.fieldIndex] = fieldObj
        // // First remove all CV Fields, then add CV Fields for computer vision actions
        // if (this.field.type === 'Computer Vision') {
        //   for (let i = this.collector.fields.length - 1; i >= 0; i--) {
        //     if (this.collector.fields[i].type === 'CV Output') {
        //       this.collector.fields.splice(i, 1)
        //     }
        //   }
        //   this.field.options.forEach(option => {
        //     if (option === 'Count Clusters') {
        //       this.collector.fields.push({
        //         label: 'CV Cluster Count',
        //         machine_name: 'cv_cluster_count',
        //         type: 'CV Output',
        //         options: [],
        //         min: false,
        //         max: false,
        //         step: false,
        //         suffix: '',
        //         required: false,
        //         group: this.field.group || false,
        //         cvSettings: {
        //           roboflowAPIKey: '',
        //           modelURL: ''
        //         }
        //       })
        //     }
        //   })
        // }
        this.$store.commit('toggleModal', 'addField')
      } else {
        if (!this.field.label) {
          // alert('You must enter a label to create this field!')
          this.$store.commit('setAlert', { active: true, message: 'You must enter a label to create this header!', level: 'alert-warning', timeout: 3000 })
          return false
        } else if (this.field.label === 'ID' || this.field.label === 'id' || this.field.label === 'iD' || this.field.label === 'Id') {
          this.$store.commit('setAlert', { active: true, message: 'The label "ID" is reserved for the system. Please change the label on this field. (example: "ID Code")', level: 'alert-warning', timeout: 6000 })
          return false
        } else {
          const snakeCase = string => {
            string = string.replace(/\W+/g, ' ').toLowerCase().split(' ').join('_')
            if (string.charAt(string.length - 1) === '_') {
              return string.substring(0, string.length - 1)
            }
            return string
          }
          let machineName = snakeCase(this.field.label)
          const originalMachineName = machineName
          // Check for other machine names of the same
          let suffix = 1
          const self = this
          function checkUniqueName () { // eslint-disable-line
            self.collector.fields.forEach((item, i) => {
              if (item.machine_name === machineName) {
                machineName = originalMachineName + '_' + suffix
                suffix++
                checkUniqueName()
              }
            })
          }
          checkUniqueName()

          const fieldObj = {
            label: this.field.label,
            type: this.field.type,
            machine_name: machineName,
            min: this.field.min,
            max: this.field.max,
            step: this.field.step,
            suffix: this.field.suffix || false,
            required: this.field.required,
            includeTime: this.field.includeTime || false,
            group: this.field.group || false,
            isLogEnabled: this.field.isLogEnabled === true,
            logValueType: this.deriveLogValueType(this.field.type),
            cvSettings: {
              roboflowAPIKey: this.field.cvSettings.roboflowAPIKey || '',
              modelURL: this.field.cvSettings.modelURL || ''
            }
          }
          if (this.field.type === 'Select') {
            fieldObj.options = this.field.options
          }
          this.collector.fields.push(fieldObj)
          // // Add Child Fields for computer vision actions
          // if (this.field.type === 'Computer Vision') {
          //   this.field.options.forEach(option => {
          //     if (option === 'Count Clusters') {
          //       this.collector.fields.push({
          //         label: 'CV Cluster Count',
          //         machine_name: 'cv_cluster_count',
          //         type: 'CV Number',
          //         options: [],
          //         min: false,
          //         max: false,
          //         step: false,
          //         suffix: '',
          //         required: false,
          //         group: this.field.group || false,
          //         cvSettings: {
          //           roboflowAPIKey: '',
          //           modelURL: ''
          //         }
          //       })
          //     }
          //   })
          // }
          this.$store.commit('toggleModal', 'addField')
        }
      }
    },
    addTag (newTag) {
      this.field.options.push(newTag)
    },
    addHeaderGroup (newGroup) {
      this.showSelects = false
      if (!this.headerGroups.includes(newGroup)) {
        this.headerGroups.push(newGroup)
      }
      this.field.group = newGroup
      setTimeout(() => {
        this.showSelects = true
      }, 10)
    },
    refreshGroupsUI () {
      this.showSelects = false
      setTimeout(() => {
        this.showSelects = true
      }, 10)
    },
    closeAddField () {
      this.$store.commit('toggleModal', 'addField')
    }
  }
}
</script>
